import React, { PropsWithChildren } from 'react';
import Stack, { StackProps } from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingText, {
  HeadingAndSupportingTextProps,
} from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import { cssVar } from 'styles/helper';

export interface VerticalContentCardProps extends PropsWithChildren {
  headingBlock?: HeadingAndSupportingTextProps;
  descriptionBlock?: HeadingAndSupportingTextProps;
  className?: string;
  justify?: StackProps['justify'];
}

const VerticalContentCard = ({
  headingBlock,
  children,
  descriptionBlock,
  className,
  justify = 'center',
}: VerticalContentCardProps): JSX.Element => {
  return (
    <Stack
      direction='column'
      padding='spacing-4xl'
      paddingSm='spacing-xl'
      justify={justify}
      align='center'
      borderRadius='radius-2xl'
      background='bg-secondary'
      border={`1px solid ${cssVar('border-secondary')}`}
      gap='spacing-3xl'
      className={className}
    >
      {headingBlock && (
        <HeadingAndSupportingText
          gap='spacing-none'
          {...headingBlock}
        />
      )}
      {children}
      {descriptionBlock && (
        <HeadingAndSupportingText
          gap='spacing-none'
          {...descriptionBlock}
        />
      )}
    </Stack>
  );
};

export default VerticalContentCard;
